import styled from 'styled-components';
import HelpIcon from '../../assets/images/help-icon.svg';

const HelpQuestionIcon = styled.span`
  background: url(\"${HelpIcon}\") no-repeat left center;
  background-size: 36px 36px;
  display: block;
  position: relative;
  width: 36px;
  height: 36px;
`;

export default HelpQuestionIcon;
